import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import cookie from 'react-cookies';
import axios from 'axios';

import Header from './components/Header';
import Content from './components/Content';

import Login from './components/Login';
import Admin from './components/Admin';
import GlobalSettings from './components/Admin/GlobalSettings';
import Roles from './components/Admin/Roles';
import Capacity from './components/Admin/Capacity';
import ProductionCycle from './components/Admin/ProductionCycle';
import AdminNews from './components/Admin/News';
import Dashboard from './components/Dashboard';
import StockSearch from './components/StockSearch';
import OrderSearch from './components/OrderSearch';
import Profile from './components/Profile';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import CustomerProfile from './components/CustomerProfile';
import Allocation from './components/Allocation';
import News from './components/News'
import Documents from './components/Documents'
import Banner from './components/Banner'
import ReactGA from 'react-ga';
import * as Grants from './components/util/grants';
import { hasGrant } from './components/util/grantHelper';
import './lib/css/bootstrap.min.css';
import './lib/css/font-awesome.min.css';

import './style.scss';

ReactGA.initialize('UA-148165684-1');

class App extends Component {

    constructor(props) {
        super(props);

        this.setApiToken = this.setApiToken.bind(this);
        this.refreshPage = this.refreshPage.bind(this);
        this.refreshHeaderFilter = this.refreshHeaderFilter.bind(this);

        this.headerRefForBanner = React.createRef()

        this.state = {
            apiToken: cookie.load('apiToken') || null,
            refresh: false,
            refreshHeader: false
        };

        ReactGA.initialize("UA-148165684-1");
        ReactGA.pageview(window.location.pathname + window.location.search);
        
    }

    // checkGrant(grant){
    //     hasGrant(grant, this.state.user);
    // }

    // refreshUser(apiToken) {
    //     let headers = {
    //         'Authorization': 'Bearer ' +  apiToken,
    //         'Accept': 'application/octet-stream'
    //     };
    //     apiHelper.getCurrentUser(headers)
    //             .then(currUser => {
    //                 this.setState({ user: currUser });
    //                 hasGrant(Grants.TYPES.Allocation_AddAllocationComments, currUser);
    //             });
    // }

    setApiToken(token) {
        if (token !== null) {
            cookie.save('apiToken', token, { maxAge: 86400 }); // 1 Week

            if (!this.state.apiToken) {
                this.setState({
                    apiToken: token,
                });
            }
        } else {
            cookie.remove('apiToken');
            this.setState({
                apiToken: null,
            });
        }
    }

    refreshPage() {
        this.setState({ refresh: true, refreshHeader: false })
    }

    refreshHeaderFilter() {
        this.setState({ refreshHeader: true })
    }

    render() {
        const { apiToken, refresh, refreshHeader } = this.state;

        return (
            <Router basename={process.env.REACT_APP_BASE_CATALOG}>
                <div>

                    <Header ref={this.headerRefForBanner} apiToken={apiToken} setApiToken={this.setApiToken} refreshPage={this.refreshPage} refreshHeader={refreshHeader} />

                    <Banner headerRef={this.headerRefForBanner} />

                    <Content>
                        {!apiToken && <Switch>
                            <Route exact path="/forgotPassword" component={() => (<ForgotPassword apiToken={apiToken} />)} />
                            <Route exact path="/resetPassword" component={() => (<ResetPassword apiToken={apiToken} />)} />
                            <Route path="*" component={() => (<Login setApiToken={this.setApiToken} refreshPage={this.refreshPage} />)} />
                        </Switch>}

                        {apiToken && <Switch>
                            <Route exact path="/" component={() => (<Dashboard refresh={refresh} apiToken={apiToken} setApiToken={this.setApiToken} />)} />
                            <Route exact path="/login" component={() => (<Login setApiToken={this.setApiToken} />)} />
                            <Route exact path="/admin" component={() => (<Admin apiToken={apiToken} setApiToken={this.setApiToken} />)} />
                            <Route exact path="/admin/globalsettings" component={() => (<GlobalSettings apiToken={apiToken} setApiToken={this.setApiToken} />)} />
                            <Route exact path="/admin/roles" component={() => (<Roles apiToken={apiToken} setApiToken={this.setApiToken} />)} />
                            <Route exact path="/admin/capacity" component={() => (<Capacity apiToken={apiToken} setApiToken={this.setApiToken} />)} />
                            <Route exact path="/admin/productioncycle" component={() => <ProductionCycle apiToken={apiToken}/>} />
                            <Route exact path="/admin/news" component={() => (<AdminNews apiToken={apiToken} setApiToken={this.setApiToken} />)} />

                            <Route exact path="/dashboard" component={() => (<Dashboard refresh={refresh} apiToken={apiToken} setApiToken={this.setApiToken} />)} />
                            <Route exact path="/stocksearch" component={() => (<StockSearch refresh={refresh} apiToken={apiToken} setApiToken={this.setApiToken} />)} />
                            <Route exact path="/ordersearch" component={() => (<OrderSearch refresh={refresh} apiToken={apiToken} setApiToken={this.setApiToken} />)} />
                            <Route exact path="/customerprofile" component={() => (<CustomerProfile refresh={refresh} apiToken={apiToken} setApiToken={this.setApiToken} />)} />
                            <Route exact path="/customerprofile/:ccr" render={(props) => (<CustomerProfile {...props} refresh={refresh} apiToken={apiToken} setApiToken={this.setApiToken} />)} />
                            <Route exact path="/allocation" component={() => (<Allocation refresh={refresh} apiToken={apiToken} setApiToken={this.setApiToken} />)} />
                            <Route exact path="/news" component={() => (<News refresh={refresh} apiToken={apiToken} setApiToken={this.setApiToken} />)} />
                            <Route exact path="/news/:id" component={(props) => (<News { ...props } refresh={refresh} apiToken={apiToken} setApiToken={this.setApiToken} />)} />
                            <Route exact path="/documents" component={() => (<Documents refresh={refresh} apiToken={apiToken} setApiToken={this.setApiToken} />)} />
                            <Route exact path="/profile" component={() => (<Profile apiToken={apiToken} setApiToken={this.setApiToken} refreshHeaderFilter={this.refreshHeaderFilter} />)} />
                            <Route path="*" component={() => (<Dashboard refresh={refresh} apiToken={apiToken} setApiToken={this.setApiToken} />)} />
                        </Switch>}
                    </Content>
                </div>
            </Router>
        );
    }
}

export default App;